import type * as models from 'pkg/api/models';
import type { CreditNoteReasonType } from 'pkg/api/models/credit_note';
import type { Dateable } from 'pkg/api/models/dateable';
import type { Record } from 'pkg/api/models/record';

export enum OrderRefundType {
	OrderRefundTypeUnknown,
	OrderRefundTypeRefund,
	OrderRefundTypeOutOfBand,
	OrderRefundTypeChargeback,
}

export enum OrderRefundStatus {
	OrderRefundStatusUnknown,
	OrderRefundStatusInitiated,
	OrderRefundStatusAccepted,
	OrderRefundStatusRejected,
}

enum OrderRefundSource {
	OrderRefundSourceUnknown,
	OrderRefundSourceInternal,
	OrderRefundSourceExternal,
}

export interface OrderRefund extends Record, Dateable {
	orderId: number;
	groupId: number;
	amount: number;
	paymentProviderId: string;
	initiatedAt: number;
	acceptedAt: number;
	rejectedAt: number;

	type: OrderRefundType;
	status: OrderRefundStatus;
	source: OrderRefundSource;
	orderChargeId: number | null;

	order: models.order.Order;
	group: models.group.Group;
}

export interface RefundChargePayload {
	chargeId: number;
	// Part of a card or by-hand charge; without it, everything left on the charge.
	amount?: number;
}

// RefundPayload is what a refund request sends to be refunded: an amount, chosen payments, or neither
// for everything left.
export interface RefundPayload {
	amount?: number;
	reasonType?: CreditNoteReasonType;
	charges?: RefundChargePayload[];
}
